import React, { useEffect } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Notification } from './notification';
import {
  severityTypes,
  severityCssClassName, severityCssClasses,
  scenarioNames,
  SeverityStringsMap,
} from './util/constants';

export const NotificationsSeverity = (props) => {
  const notifications = props.notificationList.map(notification => (
    <Notification
      key={notification.id}
      {...notification}
      actionCallback={props.actionCallback}
      isUINext={props.isUINext}
      i18n={props.i18n}
      logger={props.logger}
      logContent={props.logContent}
    />
  ));

  useEffect(() => {
    const {
      logger,
      logContent,
    } = props;

    if (logger && logContent) {
      try {
        const content = logContent(`severity=${props.severity}, notificationCount=${props.notificationList.length}`);
        logger.trace(scenarioNames.NotificationSeverity, content);
      } catch (error) {
        logger.trace(scenarioNames.NotificationSeverity, logContent('NotificationLogFailed'));
      }
    }
  }, []);

  return (
    <div className={classNames(severityCssClassName, severityCssClasses[props.severity])}>
       {props.isUINext && (
        <div role="heading" aria-level="3" className="notification-severity-header">{props.i18n.getString(SeverityStringsMap[props.severity])}</div>
       )}
      <hr />
      {notifications}
    </div>
  );
};

NotificationsSeverity.propTypes = {
  severity: PropTypes.oneOf(severityTypes).isRequired,
  notificationList: PropTypes.arrayOf(PropTypes.instanceOf(Object)).isRequired,
  actionCallback: PropTypes.func.isRequired,
  isUINext: PropTypes.bool.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  logger: PropTypes.shape({
    trace: PropTypes.func,
  }),
  logContent: PropTypes.func,
};

NotificationsSeverity.defaultProps = {
  logger: {
    trace: _.noop,
  },
  logContent: _.noop,
};
